<template>
    <div class="posts-container">
        <!-- POSTs -->
        <template v-if="resultList.length">
            <div class="favorite-posts">
                <carousel 
                    :perPageCustom="[[0, 1], [368, 2], [992, 3]]" 
                    :spacePadding="15"
                    :paginationEnabled="false"
                >
                    <slide class="slide-item" v-for="(elm, index) in resultList" :key="index">
                        <router-link 
                            tag="div" class="col-12 post-container"
                            :to="{ name: 'Post', params: { id: elm._id }}"
                        >
                            <div class="post">
                                <div 
                                    v-if="elm.Cover"
                                    alt="PostImage" class="post-img" 
                                    :style="{ 'background-image': 'url(' + URL + '/' + elm.Cover + ')' }"
                                ></div>

                                <h6 class="small-h6">{{ elm.Title }}</h6>
                                <!-- <small class="small-desc">{{ elm.Desc| truncateText(65) }}</small> -->

                                <!-- 
                                    <div class="post-footer">
                                        // Author
                                        <small id="author" >ناشر: {{ elm.Author }}</small>

                                        // Type
                                        <template v-if="elm.Type == 'business'">
                                            <img :src="KasboKar" class="icon"  alt="Type">
                                            <small id="type">کسب و کار</small>
                                        </template>
                                        <template v-else-if="elm.Type == 'crypto'">
                                            <img :src="ArzeDigital" class="icon"  alt="Type">
                                            <small id="type">ارز دیجیتال</small>
                                        </template>
                                        <template v-else-if="elm.Type == 'financial'">
                                            <img :src="Tax" class="icon"  alt="Type">
                                            <small id="type">مالی و مالیاتی</small>
                                        </template>
                                    </div> 
                                </div>
                                    </div> 
                                -->
                            </div>
                        </router-link >
                    </slide>
                </carousel>
            </div>
        </template>

        <!-- No POST Available -->
        <template v-else>
            <div class="nopost">
                <h5>مطلب مرتبطی یافت نگردید.</h5>
            </div>
        </template>
    </div>
</template>

<script>
import Tax from '@/assets/images/result-types/tax.png';
import KasboKar from '@/assets/images/result-types/kasbo_kar.png';
import ArzeDigital from '@/assets/images/result-types/arze_digital.png';

import { APP_API_URL } from '@/utils/libs/api-request';
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'FavoritePosts',
    props: {
        resultList: Array
    },
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            Tax: Tax,
            KasboKar: KasboKar,
            ArzeDigital: ArzeDigital,
            
            URL: APP_API_URL(),
        };
    },
};
</script>

<style scoped>
/* ---------------------------------------- */
/* ------------ FAVORITE POSTs ------------ */
/* ---------------------------------------- */
.post-container .favorite-posts {
    padding: 1.5rem 1rem;

    direction: ltr;
    background-color: #fece02;
}
.post-container .favorite-posts .slide-item {
    padding: 0 .5rem;
}
.post-container .favorite-posts .slide-item .inner-item {
    height: 125pt;
    border-radius: 25pt;
    overflow: hidden;
    background-color: #fff;
}

/* ---------------------------------------- */
/* ------------ POSTs Container ----------- */
/* ---------------------------------------- */
.post-container {
    min-height: 22vh;
    margin-bottom: 10pt;
    padding: 0 5px !important;

    cursor: pointer;
}
.post-container .post {
    height: 100%;
    min-height: 22vh;
    width: 100%;
    margin: auto;
    padding: 15pt 20pt;

    position: relative;

    background-color: #fff;
    border-radius: 6vh;

    direction: rtl;
}
.post-container .post h5 {
    cursor: pointer;
}
.post-container .post .post-img {
    height: 17vh;
    width: 17vh;
    margin: 0 auto 5pt;

    border: 5px solid #ddd;
    border-radius: 3vh;

    float: left;

    position: relative;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.post-container .post .post-footer {
    width: 100%;

    position: absolute;
    bottom: 15pt;

    display: flex;
    flex-direction: row;
}
.post-container .post .post-footer small {
    display: inline-block;
}
.post-container .post .post-footer .profile, 
.post-container .post .post-footer .icon {
    max-height: 17pt;
    max-width: 17pt;

    margin: auto 0;
}
.post-container .post .post-footer .profile {
    border: 1px solid #ddd;
    border-radius: 10pt;
}
#author {
    margin: auto 5px auto auto;
}
#type {
    margin: auto 5px auto 55px;
}
.post-container .small-h6 {
    text-align: center;
}
@media (max-width: 768px) {
    .post-container .post {
        display: flex;
        flex-direction: column;
    }
    .post-container .small-h6 {
        margin-top: 10pt;
        font-size: .85rem;
    }
}
@media (max-width: 576px) {
    .post-container .small-desc {
        display: none;
    }
    #author {
        margin: auto 5px auto auto;
        font-size: 70%;
    }
    #type {
        margin: auto 5px auto 35px;
        font-size: 70%;
    }
    .post-container .post .post-footer {
        bottom: 10pt;
    }
    .post-container .post .post-footer .profile, 
    .post-container .post .post-footer .icon {
        max-height: 15pt;
        max-width: 15pt;
    }
    .post-container .post {
        padding: 10pt 12pt;
    }
}

/* ---------------------------------------- */
/* ---------------- No POST --------------- */
/* ---------------------------------------- */
.posts-container .nopost {
    height: 100pt;
    width: 100%;

    margin: 0 auto !important;
    padding: 25pt 1rem;

     background-color: #fece02;
    border: 1px solid #ddd;

    display: flex;
}
.posts-container .nopost h5 {
    margin: auto;
    text-align: center;
}
</style>
